import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'Diego', 'Sofía', 'Martín', 'Valentina', 'Lucas', 'Camila', 'Sebastián'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Neuquén', 'Santa Fe'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 4000);
    // Recurring interval
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.random() * (12000 - 8000) + 8000); // Random between 8-12 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  };
  if (!visible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-slide-in-right" data-id="element-21">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-4 max-w-sm" data-id="element-22">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-23">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-24" />
        </div>
        <div data-id="element-25">
          <p className="text-sm font-medium text-gray-900" data-id="element-26">
            <span className="font-bold" data-id="element-27">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-28">
            acaba de comprar el Kit Bilingüe
          </p>
        </div>
      </div>
    </div>;
}